import { render, staticRenderFns } from "./rusak_usang.vue?vue&type=template&id=d1bf90a4&"
import script from "./rusak_usang.vue?vue&type=script&lang=js&"
export * from "./rusak_usang.vue?vue&type=script&lang=js&"
import style0 from "./rusak_usang.vue?vue&type=style&index=0&id=d1bf90a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports